import prepareHomePageStructuredPageData from "@hardware/Utilities/schemaOrg/prepareHomePageStructuredPageData";
import getJsonLdScriptId from "@insite/client-framework/Common/Utilities/getJsonLdScriptId";
import setPageMetadata from "@insite/client-framework/Common/Utilities/setPageMetadata";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { connect } from "react-redux";

// Verndale Customization - ADD home page structured data
const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);

    return {
        websiteName: state.context.website.name,
        brandPath: state.data.pages.location.pathname,
        websiteSettings: state.context.settings.settingsCollection.websiteSettings,
        page: getCurrentPage(state),
        location,
    };
};

type Props = ReturnType<typeof mapStateToProps> & PageProps;
// Verndale Customization - END

export interface HomePageStyles {
    page?: MobiusPageProps;
}

export const homePageStyles: HomePageStyles = {};
const styles = homePageStyles;

// Verndale Customization - ADD home page structured data
const HomePage = (props: Props) => {
    const { id } = props;

    const setMetadata = () => {
        const { websiteName, websiteSettings, page, location } = props;
        if (!page) {
            return;
        }

        // Prepare structured data for home page
        const structuredData = prepareHomePageStructuredPageData({
            pageTitle: page.fields.title || page.name || "Home",
            website: websiteName ? ({ companyName: websiteName } as any) : undefined,
            location: { pathname: location.pathname, search: "" },
        });

        setPageMetadata(
            {
                metaDescription: page.fields.metaDescription,
                currentPath: location.pathname,
                title: page.fields.title || page.name || "Home",
                websiteName,
                alternateLanguageUrls: page.fields.alternateLanguageUrls,
                structuredPageData: structuredData,
                jsonLdScriptId: getJsonLdScriptId(page.type),
            },
            websiteSettings,
        );
    };

    React.useEffect(() => {
        setMetadata();
    }, []);

    return (
        <Page data-test-selector="homePage" {...styles.page}>
            <Zone contentId={id} zoneName="Content" requireRows />
            <Modals />
        </Page>
    );
};
// Verndale Customization - END

const pageModule: PageModule = {
    component: connect(mapStateToProps)(HomePage),
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...StructuredPageData,
                tooltip:
                    "Code entered in this field will be added to the head of the home page. This field only supports JSON-LD data.",
            },
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "HomePage" instead of this constant.
 */
export const HomePageContext = "HomePage";
